import { gql } from '@apollo/client'
import { useMutation } from 'src/services/apollo'
import { IUseMutationOptions } from 'src/services/apollo/Mutation/useMutation'
import {
  OnboardingQualificationInstanceAttachmentCreate,
  OnboardingQualificationInstanceAttachmentCreateVariables,
} from './__gql__/useOnboardingQualificationInstanceAttachmentCreateCodeGen'

const ONBOARDING_QUALIFICATION_INSTANCE_ATTACHMENT_CREATE = gql`
  mutation OnboardingQualificationInstanceAttachmentCreate(
    $qualificationInstanceId: ID!
    $filename: String!
    $mime: String!
    $size: Int!
    $extension: String!
  ) {
    onboardingQualificationInstanceAttachmentCreate(
      input: {
        qualificationInstanceId: $qualificationInstanceId
        filename: $filename
        mime: $mime
        size: $size
        extension: $extension
      }
    ) {
      presignedUploadUrl
      document {
        id
        createdAt
        createdAtDateTime
        createdAtTimestamp: createdAtDateTime
        displayName
        downloadUrl
        downloadUrlAbsolute
        humanReadableSize
        extension
        uploadStatus
        size
        personId
        downloadUrl
        category
        sourceSystem
      }
    }
  }
`

const useOnboardingQualificationInstanceAttachmentCreate = (
  options?: IUseMutationOptions<
    OnboardingQualificationInstanceAttachmentCreate,
    OnboardingQualificationInstanceAttachmentCreateVariables
  >,
) => {
  return useMutation<
    OnboardingQualificationInstanceAttachmentCreate,
    OnboardingQualificationInstanceAttachmentCreateVariables
  >(ONBOARDING_QUALIFICATION_INSTANCE_ATTACHMENT_CREATE, {
    ...options,
  })
}

export { useOnboardingQualificationInstanceAttachmentCreate }
